module.exports = __webpack_public_path__ + "static/media/CARS1.9daef983.jpg";